import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  adjustSpace: {
    alignSelf: "flex-start",
  },
  rightContainer: {
    alignSelf: "center",
  },
  TradeVolume: {
    width: "calc(100% - 120px)",
  },
  marginBottom: {
    marginBottom: theme.spacing(6),
  },
  test: {
    "& .MuiPaper-root": {
      height: "100% !important",
    },
  },
  orderBook: {
    minHeight: theme.spacing(100),
  },
  order: {
    height: theme.spacing(134),
  },
  chart: {
    height: theme.spacing(150),
  },
  table: {
    height: theme.spacing(90),
  },
}));
